<template>
  <q-card flat bordered>
    <q-toggle v-model="visible" label="Visible TopGainerLoser" />
    <q-separator />
    <div v-show="visible">
      <div class="row">
        <div class="col-6">
          <GainersLoosersTurnoverVol
            gltv="gainer"
            :gltvtData="topGainers"
            :sectorId="selectedSectorId"
            :isMarketOn="isMarketOn"
            @propsValue="handlePropsValue($event)"
          />
        </div>
        <div class="col-6">
          <GainersLoosersTurnoverVol
            gltv="looser"
            :gltvtData="topLoosers"
            :sectorId="selectedSectorId"
            :isMarketOn="isMarketOn"
            @propsValue="handlePropsValue($event)"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <GainersLoosersTurnoverVol
            gltv="volume"
            :gltvtData="topVolumes"
            :sectorId="selectedSectorId"
            :isMarketOn="isMarketOn"
            @propsValue="handlePropsValue($event)"
          />
        </div>
        <div class="col-6">
          <GainersLoosersTurnoverVol
            gltv="turnover"
            :gltvtData="topTurnovers"
            :sectorId="selectedSectorId"
            :isMarketOn="isMarketOn"
            @propsValue="handlePropsValue($event)"
          />
          <!-- <GainersLoosersTurnoverVol
            gltv="transaction"
            :gltvtData="topTransaction"
            :sectorId="selectedSectorId"
            :isMarketOn="isMarketOn"
            @propsValue="handlePropsValue($event)"
          /> -->
        </div>
      </div>
    </div>
    <q-separator />
  </q-card>
</template>

<script setup>
import { ref } from "vue";
import GainersLoosersTurnoverVol from "src/components/GainersLoosersTurnoverVol.vue";

// Props
const props = defineProps({
  topTransaction: {
    type: Array,
  },
  topVolumes: {
    type: Array,
  },
  topTurnovers: {
    type: Array,
  },
  topGainers: {
    type: Array,
  },
  topLoosers: {
    type: Array,
  },
  isMarketOn: {
    type: Boolean,
    required: false,
    default: false,
  },
  selectedSectorId: {
    type: Number,
    required: false,
    default: null,
  },
});

// Emits
const emit = defineEmits(["tableSymbol"]);

// Local State
const visible = ref(true);

// Methods
function handlePropsValue(event) {
  emit("tableSymbol", event);
}
</script>
